import { ShoesSize } from '../models/ShoesSize';
import { SizeChart } from '../models/SizeChart';

export class CartRequest {
    public userId: string;
    public productId: string;
    public shoesSizeObj: ShoesSize;
    public sizeChartObj: SizeChart;
    public fromDate: Date;
    public toDate: Date;
    public quantity: number = 0;
}
